const ERROR_CODES = {
  UNKNOWN: 'unknown.unknown',
  // invitation/service/invitation_service.go: the invitation's member row is gone or used.
  INVITATION_ACTIVE_INVITATION_NOT_FOUND: 'invitation.active_invitation_not_found',
  // The api raises this as contact.address_taken (contact/service/contact_service.go);
  // the old 'address.address_taken' never matched anything (ENG-5322).
  ADDRESS_ADDRESS_TAKEN: 'contact.address_taken',
  CONTACT_MUST_HAVE_PRIMARY: 'contact.must_have_primary',
  // ENG-6322: a number that does not parse as a phone, and setAddress refusing an
  // unconfirmed primary phone while the user's sign-in codes go to their phone by
  // text. The second sends them through the texted-code flow in Settings.
  CONTACT_PHONE_INVALID: 'contact.phone_invalid',
  CONTACT_PHONE_NEEDS_VERIFICATION: 'contact.phone_needs_verification',
  // The passwordless and phone verification codes (api auth/userpool/db/passwordless.go)
  // keep the api's upper-snake form.
  OTP_INVALID: 'OTP_INVALID',
  OTP_EXPIRED: 'OTP_EXPIRED',
  OTP_MAX_ATTEMPTS_EXCEEDED: 'OTP_MAX_ATTEMPTS_EXCEEDED',
  OTP_RATE_LIMIT_EXCEEDED: 'OTP_RATE_LIMIT_EXCEEDED',
  OTP_SEND_FAILED: 'OTP_SEND_FAILED',
  AUTH_INVALID_CREDENTIALS: 'auth.invalid_credentials',
  // createToken got no user id and the request authenticated no one. For a password
  // login that means the Authorization header never reached the api: some corporate
  // networks strip it (ENG-5831, Sentry WEBAPP-BRY).
  AUTH_CREDENTIALS_MISSING: 'auth.credentials_missing',
  AUTH_EMAIL_ALREADY_EXISTS: 'auth.email_already_exists',
  // The signup pre-create check (api profile_service.go HandlePreUserCreate):
  // another live account holds the submitted phone.
  AUTH_PHONE_ALREADY_EXISTS: 'auth.phone_already_exists',
  AUTH_PASSWORD_REQUIREMENTS: 'auth.password_requirements',
  AUTH_MFA_SETUP_REQUIRED: 'auth.mfa_setup_required',
  AUTH_MFA_REQUIRED: 'auth.mfa_required',
  AUTH_LOCKED_FOR_INTERVAL: 'auth.locked_for_interval',
  // ENG-6103: Cognito throttled the sign-in (TooManyRequests, LimitExceeded, or
  // "Password attempts exceeded"). Raised by the webapp's Cognito sign-in
  // wrapper, not by the api: unlike locked_for_interval there is no fixed
  // 24-hour lock and no remaining-attempts count, so it needs its own copy.
  AUTH_TOO_MANY_ATTEMPTS: 'auth.too_many_attempts',
  AUTH_OTP_INVALID: 'auth.otp_invalid',
  AUTH_PASSWORD_NOT_EQUAL: 'auth.password_not_equal',
  AUTH_PASSWORD_REUSED: 'auth.password_reused',
  AUTH_TOKEN_EXPIRED: 'auth.token_expired',
  AUTH_TOKEN_INVALID: 'auth.token_invalid',
  AUTH_API_KEY_INVALID: 'auth.api_key_invalid',
  AUTH_USER_NOT_FOUND: 'auth.user_not_found',
  AUTH_UNAUTHORIZED: 'auth.unauthorized',
  AUTH_INVALID_OTP_TOKEN: 'auth.invalid_otp_token',
  AUTH_OTP_TOKEN_EXPIRED: 'auth.otp_token_expired',
  AUTH_INVALID_TRANSPORT: 'auth.invalid_transport',
  AUTH_INVALID_EMAIL: 'auth.invalid_email',
  AUTH_SEND_OTP_FAILED: 'auth.send_otp_failed',
  AUTH_MFA_ENROLLMENT_REQUIRED: 'auth.mfa_enrollment_required',
  // ENG-6164 social sign-in (auth/social on the api). social_token_invalid is
  // also raised by the webapp's social sign-in when Cognito refuses the ticket.
  AUTH_SOCIAL_DISABLED: 'auth.social_disabled',
  AUTH_SOCIAL_TOKEN_INVALID: 'auth.social_token_invalid',
  AUTH_SOCIAL_EMAIL_UNVERIFIED: 'auth.social_email_unverified',
  AUTH_SOCIAL_IDENTITY_TAKEN: 'auth.social_identity_taken',
  AUTH_SOCIAL_NOT_LINKED: 'auth.social_not_linked',
  AUTH_SOCIAL_SIGNUP_TOKEN_INVALID: 'auth.social_signup_token_invalid',
  // ENG-6192 connected accounts: the connect token lapsed, a second identity of
  // one provider, and disconnecting the only way left to sign in.
  AUTH_SOCIAL_CONNECT_TOKEN_INVALID: 'auth.social_connect_token_invalid',
  AUTH_SOCIAL_PROVIDER_CONNECTED: 'auth.social_provider_connected',
  AUTH_SOCIAL_LAST_SIGN_IN_METHOD: 'auth.social_last_sign_in_method',
  CONFERENCE_HOST_CONFERENCE_NOT_FOUND: 'conference.host_conference_not_found',
  CONFERENCE_NOT_FOUND: 'conference.not_found',
  CONSULTATION_NOT_FOUND: 'consultation.not_found',
  CONSULTATION_COMPLIANCE_TRAINING_REQUIRED: 'consultation.compliance_training_required',
  // The expert has no account, so no call was created; the api emailed them instead.
  CONSULTATION_UNREGISTERED_EXPERT_REQUEST: 'consultation.unregistered_expert_request',
  // An attachment url that resolves to no OnFrontiers-controlled storage
  // backend (api ENG-5672). Only reachable by a client that supplies its own
  // file_url — the Filestack picker always yields an owned url — so this is a
  // contract marker rather than a case the current UI can hit.
  CONSULTATION_ATTACHMENT_INVALID: 'consultation.attachment_invalid',
  // The generic conversation surface (api CV-4 ENG-5497 / CV-5 ENG-5498;
  // tla/Common.tla ConversationErrorCodes — a closed set of six). The
  // engagement messaging operations keep answering engagement.* — the api
  // maps the codes back at its façade — so these fire only on the generic
  // conversation* operations.
  CONVERSATION_CHANNEL_NOT_FOUND: 'conversation.channel_not_found',
  CONVERSATION_CHANNEL_FORBIDDEN: 'conversation.channel_forbidden',
  CONVERSATION_CHANNEL_TYPE_INVALID: 'conversation.channel_type_invalid',
  CONVERSATION_MESSAGE_INVALID: 'conversation.message_invalid',
  CONVERSATION_CHANNEL_UNAVAILABLE: 'conversation.channel_unavailable',
  // The sixth code (api ENG-5746): channel_unavailable's PERMANENT sibling.
  // The sender has no Sendbird user record and Sendbird refused to create one,
  // so the same request has the same answer forever. It is a separate code
  // only so the copy can stop telling people to retry.
  CONVERSATION_MESSAGING_SETUP_FAILED: 'conversation.messaging_setup_failed',
  EXPERT_BILL_RATE_TOO_HIGH: 'expert.bill_rate_too_high',
  EXPERT_REQUEST_NOT_FOUND: 'expertrequest.not_found',
  EXPERT_REQUEST_NOT_ACTIVE: 'expertrequest.not_active',
  EXPERT_REQUEST_HAS_OPEN_CONSULTATIONS: 'expertrequest.has_open_consultations',
  EXPERT_REQUEST_FIELD_TOO_LONG: 'expertrequest.field_too_long',
  EXPERT_REQUEST_INVALID_STAGE_TRANSITION: 'expertrequest.invalid_stage_transition',
  EXPERT_REQUEST_INVALID_CLOSE_REASON: 'expertrequest.invalid_close_reason',
  EXPERT_REQUEST_STAGE_CONFLICT: 'expertrequest.stage_conflict',
  EXPERT_REQUEST_CLOSE_REASON_TOO_LONG: 'expertrequest.close_reason_too_long',
  EXPERT_REQUEST_FIELD_NOT_EDITABLE: 'expertrequest.field_not_editable',
  EXPERT_REQUEST_INVALID_CURSOR: 'expertrequest.invalid_cursor',
  // See CONSULTATION_ATTACHMENT_INVALID — same gate, expert request surface.
  EXPERT_REQUEST_ATTACHMENT_INVALID: 'expertrequest.attachment_invalid',
  EXPERT_REQUEST_INVALID_ORIGIN: 'expertrequest.invalid_origin',
  EXPERT_REQUEST_CROSS_GROUP_MOVE_NOT_SUPPORTED: 'expertrequest.cross_group_move_not_supported',
  EXPERT_REQUEST_BILLING_ACCOUNT_CHANGED_CONCURRENTLY:
    'expertrequest.billing_account_changed_concurrently',
  // ENG-5670: the account has consulting engagements, so the consulting_project
  // ER type is closed to it. Raised by the api at create and at a type change.
  EXPERT_REQUEST_ER_TYPE_NOT_AVAILABLE: 'expertrequest.er_type_not_available',
  // ENG-5322: four user-reachable rules that used to share expertrequest.unknown.
  EXPERT_REQUEST_CANDIDATE_ALREADY_ADDED: 'expertrequest.candidate_already_added',
  EXPERT_REQUEST_CANDIDATE_NOT_ELIGIBLE: 'expertrequest.candidate_not_eligible',
  EXPERT_REQUEST_QUERY_RESPONSE_REQUIRED: 'expertrequest.query_response_required',
  EXPERT_REQUEST_UNPAID_REQUIRES_FULL_DISCLOSURE: 'expertrequest.unpaid_requires_full_disclosure',
  // ENG-6310: invitations the staff MCP prepares are sent only from the app, by
  // the staff member who prepared them. Raised by candidateInvitationBatch and
  // its send/cancel mutations.
  INVITATION_BATCH_NOT_FOUND: 'invitation_batch.not_found',
  INVITATION_BATCH_EXPIRED: 'invitation_batch.expired',
  // Already sent or cancelled. On send this is the safe double-click outcome:
  // the batch went out once.
  INVITATION_BATCH_NOT_PENDING: 'invitation_batch.not_pending',
  INVITATION_BATCH_DAILY_LIMIT: 'invitation_batch.daily_limit',
  // Not the preparer, or an app principal rather than a signed-in user.
  INVITATION_BATCH_FORBIDDEN: 'invitation_batch.forbidden',
  // The preparer's edit of the subject or body can't be sent (empty, too long, a
  // field outside the api's allowlist, or no opportunity link). The api's
  // message says which; nothing changed.
  INVITATION_BATCH_INVALID_EMAIL: 'invitation_batch.invalid_email',
  // ENG-5727: the four create-authority refusals. The api grants
  // engagement:create by policy, but the global staff wildcard carries no
  // resource restriction, so these are the domain guard that runs after it —
  // see api engagement/service/create_authority.go.
  //
  // ACCOUNT_NOT_ENTITLED is the one to HIDE on rather than explain: never
  // advertise a product the customer has not bought. The three membership
  // codes are meant to be explained, naming what is missing, which is why
  // there are three rather than one.
  //
  // Prefer the read field `Project.viewer_engagement_create_denial`, which
  // answers the same question before the user acts. These are the backstop for
  // a field that was read before a membership changed.
  ENGAGEMENT_ACCOUNT_NOT_ENTITLED: 'engagement.account_not_entitled',
  ENGAGEMENT_ACTOR_NOT_GROUP_MEMBER: 'engagement.actor_not_group_member',
  ENGAGEMENT_ACTOR_NOT_PROJECT_MEMBER: 'engagement.actor_not_project_member',
  ENGAGEMENT_ACTOR_NOT_GROUP_OR_PROJECT_MEMBER: 'engagement.actor_not_group_or_project_member',
  ENGAGEMENT_ACTOR_REQUIRED: 'engagement.actor_required',
  ENGAGEMENT_AMENDMENT_ALREADY_OPEN: 'engagement.amendment_already_open',
  ENGAGEMENT_AMENDMENT_INVALID_CHANGE_SET: 'engagement.amendment_invalid_change_set',
  ENGAGEMENT_AMENDMENT_NOT_ACTIONABLE: 'engagement.amendment_not_actionable',
  ENGAGEMENT_AMENDMENT_NOT_COUNTERPARTY: 'engagement.amendment_not_counterparty',
  ENGAGEMENT_AMENDMENT_NOT_FOUND: 'engagement.amendment_not_found',
  ENGAGEMENT_AMENDMENT_NOT_PARTICIPANT: 'engagement.amendment_not_participant',
  ENGAGEMENT_AMENDMENT_NOT_PROPOSER: 'engagement.amendment_not_proposer',
  ENGAGEMENT_AMENDMENT_NTE_BELOW_CONFIRMED: 'engagement.amendment_nte_below_confirmed',
  ENGAGEMENT_AMENDMENT_PRICING_CONFIG_MISSING: 'engagement.amendment_pricing_config_missing',
  ENGAGEMENT_AWAITING_MISMATCH: 'engagement.awaiting_mismatch',
  // ENG-5688: the three recoverable refusals of closeEngagement. Each names what
  // is outstanding, so the Hub can render a next step rather than a dead end.
  // close_hours_unbilled only fires where the billing routines are running — it
  // is a wait for the next period_close tick, not a wall.
  ENGAGEMENT_CLOSE_HOURS_PENDING: 'engagement.close_hours_pending',
  ENGAGEMENT_CLOSE_HOURS_UNBILLED: 'engagement.close_hours_unbilled',
  ENGAGEMENT_CLOSE_PERIOD_UNRESOLVED: 'engagement.close_period_unresolved',
  ENGAGEMENT_BILLING_SETTINGS_ACTIVE_ENGAGEMENTS_EXIST:
    'engagement.billing_settings.active_engagements_exist',
  ENGAGEMENT_BILLING_SETTINGS_ALREADY_ENABLED: 'engagement.billing_settings.already_enabled',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_ALERT_PCT: 'engagement.billing_settings.invalid_alert_pct',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_FUNDING_METHOD:
    'engagement.billing_settings.invalid_funding_method',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_GOVERNANCE_THRESHOLD:
    'engagement.billing_settings.invalid_governance_threshold',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_INVOICE_TERMS:
    'engagement.billing_settings.invalid_invoice_terms',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_MIN_HOURS: 'engagement.billing_settings.invalid_min_hours',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_POLICY_TYPE:
    'engagement.billing_settings.invalid_policy_type',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_TAKE_RATES: 'engagement.billing_settings.invalid_take_rates',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_THRESHOLDS: 'engagement.billing_settings.invalid_thresholds',
  ENGAGEMENT_BILLING_SETTINGS_INVALID_TIMER_DAYS: 'engagement.billing_settings.invalid_timer_days',
  ENGAGEMENT_BILLING_SETTINGS_NO_BILLING_ACCOUNT: 'engagement.billing_settings.no_billing_account',
  ENGAGEMENT_BILLING_SETTINGS_NO_TEAM: 'engagement.billing_settings.no_team',
  ENGAGEMENT_BILLING_SETTINGS_NOT_ENABLED: 'engagement.billing_settings.not_enabled',
  ENGAGEMENT_BILLING_SETTINGS_PLAN_NOT_ELIGIBLE: 'engagement.billing_settings.plan_not_eligible',
  ENGAGEMENT_CHANNEL_FORBIDDEN: 'engagement.channel_forbidden',
  ENGAGEMENT_CHANNEL_NOT_FOUND: 'engagement.channel_not_found',
  ENGAGEMENT_CHANNEL_TYPE_INVALID: 'engagement.channel_type_invalid',
  ENGAGEMENT_CHANNEL_UNAVAILABLE: 'engagement.channel_unavailable',
  // ENG-5746. The engagement wrapper of conversation.messaging_setup_failed,
  // and the one of the pair that actually reaches users today, since the
  // Messages tab sends through sendEngagementMessage.
  ENGAGEMENT_MESSAGING_SETUP_FAILED: 'engagement.messaging_setup_failed',
  ENGAGEMENT_DUPLICATE_PRIMARY_ALLOCATION: 'engagement.duplicate_primary_allocation',
  ENGAGEMENT_NOT_ACTIVE: 'engagement.engagement_not_active',
  ENGAGEMENT_EXPERT_PAYOUTS_NOT_ENABLED: 'engagement.expert_payouts_not_enabled',
  ENGAGEMENT_EXPERT_RATE_INVALID: 'engagement.expert_rate_invalid',
  ENGAGEMENT_EXPERT_REQUIRED: 'engagement.expert_required',
  ENGAGEMENT_EXPERT_UNRESOLVABLE: 'engagement.expert_unresolvable',
  ENGAGEMENT_GOVERNANCE_APPROVER_REQUIRED: 'engagement.governance_approver_required',
  ENGAGEMENT_GOVERNANCE_INVALID_DECISION: 'engagement.governance_invalid_decision',
  ENGAGEMENT_GOVERNANCE_INVALID_NTE: 'engagement.governance_invalid_nte',
  ENGAGEMENT_GOVERNANCE_NOTE_REQUIRED: 'engagement.governance_note_required',
  ENGAGEMENT_GOVERNANCE_NOTE_TOO_LONG: 'engagement.governance_note_too_long',
  ENGAGEMENT_HOURS_ACTOR_NOT_EXPERT: 'engagement.hours_actor_not_expert',
  ENGAGEMENT_HOURS_ACTOR_NOT_WORK_APPROVER: 'engagement.hours_actor_not_work_approver',
  ENGAGEMENT_HOURS_INVALID: 'engagement.hours_invalid',
  ENGAGEMENT_INVALID_CONFIRM_MODE: 'engagement.invalid_confirm_mode',
  ENGAGEMENT_INVALID_CONFIRMED_HOURS: 'engagement.invalid_confirmed_hours',
  ENGAGEMENT_INVALID_CREATION_PATH: 'engagement.invalid_creation_path',
  ENGAGEMENT_INVALID_DATES: 'engagement.invalid_dates',
  ENGAGEMENT_INVALID_ESTIMATED_HOURS: 'engagement.invalid_estimated_hours',
  ENGAGEMENT_INVALID_RESOLVE_OUTCOME: 'engagement.invalid_resolve_outcome',
  ENGAGEMENT_INVALID_SOURCE_REF: 'engagement.invalid_source_ref',
  ENGAGEMENT_INVALID_TRANSITION: 'engagement.invalid_transition',
  ENGAGEMENT_MESSAGE_INVALID: 'engagement.message_invalid',
  ENGAGEMENT_NOT_FOUND: 'engagement.not_found',
  ENGAGEMENT_NOT_GOVERNANCE_APPROVER: 'engagement.not_governance_approver',
  ENGAGEMENT_NOTE_REQUIRED: 'engagement.note_required',
  ENGAGEMENT_NOTE_TOO_LONG: 'engagement.note_too_long',
  ENGAGEMENT_NOTIFICATION_CLASS_INVALID: 'engagement.notification_class_invalid',
  ENGAGEMENT_NTE_EXCEEDED: 'engagement.nte_exceeded',
  ENGAGEMENT_NTE_HOURS_BELOW_MINIMUM: 'engagement.nte_hours_below_minimum',
  // The six refusals of retryEngagementBillingPeriod (api ENG-5630) — the OF
  // operator retry of a billing period whose funding failed. These are the
  // first engagement MONEY-side codes a client can reach at all: every other
  // one on that path is emitted by the period-close routine, which no client
  // touches, and the guard row's own failure_reason vocabulary
  // (credit_shortfall, pricing_config_invalid, …) is returned as DATA on the
  // result type rather than as an error code.
  //
  // PERIOD_NOT_FAILED and PERIOD_NOT_FOUND are deliberately DISTINCT, and must
  // stay that way in any copy written against them. The api originally answered
  // both with period_not_failed on an anti-enumeration argument that did not
  // hold — the staff gate is only satisfied by staff already entitled to every
  // billing period — so a mistyped or stale id rendered a state explanation for
  // a row that has no state. NOT_FAILED means the row exists and is settled,
  // skipped or voided; NOT_FOUND means check the id.
  //
  // PERIOD_RETRY_LOST is a SAFE outcome, not a fault: two operators clicked and
  // the CAS admitted one, so exactly one retry ran. Surface it the way
  // duplicate_live_payment is surfaced — an explanation, not a red error.
  ENGAGEMENT_PERIOD_NOT_FAILED: 'engagement.period_not_failed',
  ENGAGEMENT_PERIOD_NOT_FOUND: 'engagement.period_not_found',
  ENGAGEMENT_PERIOD_NOT_RETRYABLE: 'engagement.period_not_retryable',
  ENGAGEMENT_PERIOD_RETRY_LOST: 'engagement.period_retry_lost',
  ENGAGEMENT_RETRY_NOTE_REQUIRED: 'engagement.retry_note_required',
  ENGAGEMENT_RETRY_SETTINGS_NOT_READY: 'engagement.retry_settings_not_ready',
  ENGAGEMENT_PROJECT_ACCOUNT_MISMATCH: 'engagement.project_account_mismatch',
  ENGAGEMENT_PROJECT_SETTINGS_INVALID_OVERRIDE: 'engagement.project_settings.invalid_override',
  ENGAGEMENT_PREVIEW_RATE_UNAVAILABLE: 'engagement.preview_rate_unavailable',
  ENGAGEMENT_RESOLUTION_TOO_LONG: 'engagement.resolution_too_long',
  ENGAGEMENT_SCOPE_TOO_LONG: 'engagement.scope_too_long',
  ENGAGEMENT_SOURCE_NOT_FOUND: 'engagement.source_not_found',
  ENGAGEMENT_SUBMISSION_NOT_ESCALATED: 'engagement.submission_not_escalated',
  ENGAGEMENT_SUBMISSION_NOT_FOUND: 'engagement.submission_not_found',
  ENGAGEMENT_SUBMISSION_NOT_SUBMITTED: 'engagement.submission_not_submitted',
  ENGAGEMENT_TAKE_RATE_INVALID: 'engagement.take_rate_invalid',
  ENGAGEMENT_TRANSITION_FROM_TERMINAL: 'engagement.transition_from_terminal',
  ENGAGEMENT_WORK_APPROVER_NOT_OWNER: 'engagement.work_approver_not_owner',
  ENGAGEMENT_WORK_DESCRIPTION_REQUIRED: 'engagement.work_description_required',
  // The api's group service raises team.*, never group.* (ENG-5322).
  GROUP_NOT_FOUND: 'team.not_found',
  GROUP_MEMBER_NOT_FOUND: 'team.member_not_found',
  BILLING_SEATS_EXHAUSTED: 'billing.seats_exhausted',
  BILLING_SUBSCRIPTION_INACTIVE: 'billing.subscription_inactive',
  BILLING_SUBSCRIPTION_NOT_REACTIVATABLE: 'billing.subscription_not_reactivatable',
  BILLING_SUBSCRIPTION_NOT_MODIFIABLE: 'billing.subscription_not_modifiable',
  BILLING_PAYMENT_METHOD_REQUIRED: 'billing.payment_method_required',
  // requireAdmin's refusal. completeSMBSignup returns it to any Bearer viewer who is not a
  // pending self-service signup: an existing account without billing, or a replay after the
  // signup already went through (ENG-5549).
  BILLING_UNAUTHORIZED: 'billing.unauthorized',
  BILLING_INVALID_CREDIT_PRICING: 'billing.invalid_credit_pricing',
  BILLING_INVALID_SITE_CREDIT_PRICING: 'billing.invalid_site_credit_pricing',
  // Write-time rejection of a bad take_rate argument on provisionBillingAccount
  // (ENG-5125). Caller-actionable, and distinct from the two "unavailable"
  // codes below, which mean the STORED row cannot be priced against.
  BILLING_INVALID_TAKE_RATE: 'billing.invalid_take_rate',
  BILLING_TAKE_RATE_UNAVAILABLE: 'billing.take_rate_unavailable',
  BILLING_SITE_TAKE_RATE_UNAVAILABLE: 'billing.site_take_rate_unavailable',
  // Row-scoped: the rate being priced is not denominated in USD (legacy empty
  // *_currency column; ENG-5518 backfilled these). Distinct from the account-
  // scoped "unavailable" codes above — the repair is on the row, not the
  // account. Reaches the client from consultation booking previews.
  BILLING_UNPRICEABLE_RATE: 'billing.unpriceable_rate',
  BILLING_INVALID_TRIAL_DAYS: 'billing.invalid_trial_days',
  BILLING_IDEMPOTENCY_IN_PROGRESS: 'billing.idempotency_in_progress',
  BILLING_IDEMPOTENCY_KEY_REQUIRED: 'billing.idempotency_key_required',
  BILLING_IDEMPOTENCY_CONFLICT: 'billing.idempotency_conflict',
  BILLING_INVALID_IDEMPOTENCY_KEY: 'billing.invalid_idempotency_key',
  BILLING_STRIPE_CUSTOMER_INVALID: 'billing.stripe_customer_invalid',
  BILLING_PRICING_UNAVAILABLE: 'billing.pricing_unavailable',
  BILLING_SIGNUP_FAILED: 'billing.signup_failed',
  SMB_SIGNUP_PENDING_PROJECT_INVITE: 'smb_signup.pending_project_invite',
  SMB_SIGNUP_ACTIVE_MEMBERSHIP_EXISTS: 'smb_signup.active_membership_exists',
  // Emitted from pendingProjectInviteQuery and completeSMBSignup (ENG-5334)
  // when the authenticated/OTP-verified user has no verified primary email
  // on file. Distinct from "no pending invite": the caller should show a
  // recoverable error rather than silently falling open to the paid funnel.
  AUTH_EMAIL_REQUIRED: 'auth.email_required',
  AUTH_ACCOUNT_EXISTS_LOGIN_REQUIRED: 'auth.account_exists_login_required',
  GROUP_NOT_JOINABLE: 'group_not_joinable',
  GROUP_ALREADY_MEMBER_OR_PENDING: 'already_member_or_pending',
  GROUP_EMAIL_DOMAIN_MISMATCH: 'email_domain_mismatch',
  PERMISSION_NOT_ALLOWED: 'permission.not_allowed',
  TEAM_MEMBER_HAS_ACTIVE_CONSULTATIONS: 'team.member_has_active_consultations',
  TEAM_MEMBER_HAS_ACTIVE_REQUESTS: 'team.member_has_active_requests',
  TEAM_CANNOT_REMOVE_LAST_OWNER: 'team.cannot_remove_last_owner',
  TEAM_OWNER_CANNOT_CHANGE_ROLE: 'team.owner_cannot_change_role',
  TEAM_CANNOT_TRANSFER_TO_SELF: 'team.cannot_transfer_to_self',
  TEAM_CANNOT_TRANSFER_TO_PENDING: 'team.cannot_transfer_to_pending',
  TEAM_OWNER_MUST_TRANSFER_FIRST: 'team.owner_must_transfer_first',
  TEAM_ALREADY_HAS_OWNER: 'team.already_has_owner',
  TEAM_NO_OWNER_USE_ASSIGN: 'team.no_owner_use_assign',
  PROFILE_NOT_FOUND: 'profile.not_found',
  PROFILE_INVALID_NAME: 'profile.invalid_name',
  PROFILE_FIRST_NAME_TOO_LONG: 'profile.first_name_too_long',
  PROFILE_LAST_NAME_TOO_LONG: 'profile.last_name_too_long',
  PROJECT_NOT_FOUND: 'project.not_found',
  // Emitted by project/service/member.go on add/update/remove project member —
  // paths actions/project.ts calls. Unregistered until now; completing the set so
  // the mirror-contract test below can assert set-equality with the API.
  PROJECT_MEMBER_NOT_FOUND: 'project.member_not_found',
  PROJECT_UNKNOWN: 'project.unknown',
  PROJECT_GROUP_CHANGE_NOT_SUPPORTED: 'project.group_change_not_supported',
  PROJECT_SUBSTITUTE_CROSSES_TEAM: 'project.substitute_crosses_team',
  PROJECT_SUBSTITUTE_DELETED: 'project.substitute_deleted',
  PROJECT_SUBSTITUTE_IS_PROJECT: 'project.substitute_is_project',
  EXPERT_PAYMENT_NOT_CLAIMABLE: 'expert_payment.not_claimable',
  EXPERT_PAYMENT_PAYOUTS_NOT_ENABLED: 'expert_payment.payouts_not_enabled',
  EXPERT_PAYMENT_EXECUTION_DISABLED: 'expert_payment.execution_disabled',
  EXPERT_PAYMENT_DUPLICATE_LIVE_PAYMENT: 'expert_payment.duplicate_live_payment',
  EXPERT_PAYMENT_AMOUNT_IMMUTABLE: 'expert_payment.amount_immutable',
  EXPERT_PAYMENT_INVALID_INPUT: 'expert_payment.invalid_input',
  EXPERT_PAYMENT_NOT_FOUND: 'expert_payment.not_found',
  EXPERT_PAYMENT_TOO_FRESH: 'expert_payment.too_fresh',
  PAYOUT_ACCOUNT_NOT_FOUND: 'payout.account_not_found',
  PAYOUT_COUNTRY_UNSUPPORTED: 'payout.country_unsupported',
  // ENG-5723 closed the four remaining `unknown.unknown` emissions on this
  // surface. COUNTRY_REQUIRED is ours; the other three are the api's
  // translation of a Stripe rejection, which used to reach the browser as a
  // raw *stripe.Error and so could not be branched on at all.
  //
  // COUNTRY_REQUIRED is distinct from COUNTRY_UNSUPPORTED in the only way that
  // matters to copy: this one the expert can fix themselves, in seconds, and a
  // brand-new expert is always in it — nothing in signup or onboarding collects
  // a country, so it reaches the profile only through the Location form.
  PAYOUT_COUNTRY_REQUIRED: 'payout.country_required',
  // Stripe refused a parameter the api could name in the profile's own words.
  // Its message interpolates the field, so surfaces prefer the server's message
  // over the static default below.
  PAYOUT_SETUP_REJECTED: 'payout.setup_rejected',
  // A burned idempotency key. ENG-5724 removed the cause; this is the guard
  // rail if it recurs, and the one payout failure where retrying later works.
  PAYOUT_SETUP_RETRY_LATER: 'payout.setup_retry_later',
  // Any other Stripe rejection. Deliberately opaque — the detail stays in the
  // api's logs rather than crossing to the client.
  PAYOUT_SETUP_FAILED: 'payout.setup_failed',
  // Cross-cutting, not one domain's: paging/paging.go raises both for every
  // cursor-paged query. Registered because the expert-payments ledger takes an
  // `after` cursor and a `first`, so both are reachable from a real surface —
  // and a rejected cursor needs different copy from a generic read failure,
  // since retrying with the same cursor can only fail the same way.
  PAGING_INVALID_ARGUMENT: 'paging.invalid_argument',
  PAGING_CURSOR_INVALID: 'paging.cursor_invalid',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export default ERROR_CODES;
